import { Decli } from "@/config/opConfig";

/**
 * Redirect URLs for countries where the referral platform is paused
 */
export const COUNTRY_REDIRECT_URLS: Record<string, string> = {
  fr: "https://www.optical-center.fr/contact",
  "be-fr": "https://www.optical-center.be/fr/contact",
  "be-nl": "https://de.optical-center.fr/kontakt",
  en: "https://www.optical-center.co.uk/contact-us",
  "sz-fr": "https://www.optical-center.ch/contact",
  "sz-de": "https://www.optical-center.ch/de/kontakt",
  es: "https://www.optical-center.es/contacto",
  "ca-fr": "https://www.optical-center.ca/contact",
  "ca-en": "https://www.optical-center.ca/en/contact-us",
  // is: "https://www.optical-center.co.il/contact-us",
};

/**
 * Countries where the referral platform remains active
 */
export const ACTIVE_COUNTRIES = ["is"]; // Israel

/**
 * Check if the current decli should be redirected
 * @param decli - Current decli object
 * @returns boolean - true if should redirect
 */
export function shouldRedirectCountry(decli: Decli): boolean {
  return !ACTIVE_COUNTRIES.includes(decli.name);
}

/**
 * Get the redirect URL for a specific decli
 * @param decli - Current decli object
 * @returns string | null - Redirect URL or null if no redirect needed
 */
export function getRedirectUrl(decli: Decli): string | null {
  if (!shouldRedirectCountry(decli)) {
    return null;
  }

  return COUNTRY_REDIRECT_URLS[decli.name] || null;
}

/**
 * Check if the application is running in a Cypress test environment
 * @returns boolean - true if running in Cypress
 */
export function isCypressTestEnvironment(): boolean {
  return typeof window !== "undefined" && !!(window as Window & { Cypress?: unknown }).Cypress;
}

/**
 * Perform redirect for paused countries
 * @param decli - Current decli object
 */
export function performCountryRedirect(decli: Decli): void {
  // Skip redirect during e2e tests
  if (isCypressTestEnvironment()) {
    return;
  }

  const redirectUrl = getRedirectUrl(decli);

  if (redirectUrl) {
    window.location.href = redirectUrl;
  }
}
